import alerts from "./alerts.json";
import form from "./form.json";

const NosShowPenalityConfig = {
    alerts,
    form,
};

export default NosShowPenalityConfig;